module.exports = __webpack_public_path__ + "static/img/cooperation8.e020bf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newImgs/cooperation8.png
// module id = N3vX
// module chunks = 11